<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide"

export default {
  props: {
    options: { type: [String, Object], default: null },
  },

  data: () => ({
    setOptions: {
      horizontal: {
        rewind: false,
        autoplay: false,
        arrows: true,
        focus: 'left',
        gap: '1.5rem',
        fixedWidth: '18.75rem',
        pagination: false,
        trimSpace: 'move',
        padding: {
          left: 15,
          right: 15,
        }
      }
    },

    defaultOptions: {
      rewind: true,
      loop: true,
      focus: 'center',
      arrows: false,
      autoplay: true,
      interval: 8000,
    }
  }),

  computed: {
    computedOptions () {
      let options = { ...this.defaultOptions }

      if (typeof this.options === 'string') {
        options = { ...options, ...this.setOptions[this.options] }
      } else if (typeof this.options === 'object') {
        options = { ...options, ...this.options }
      }

      return options
    }
  },

  methods: {
    ready () {
      this.$nextTick(() => {
        const ref = this.$refs.slide
        const screen = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        const container = ref.$el.querySelector('.splide__list').offsetWidth

        ref.splide.options = {...this.computedOptions, arrows: this.computedOptions.arrows && container > screen }

        ref.remount()
      })
    }
  },

  render (createElement) {
    const items = this.$scopedSlots['default']()

    return createElement(
      Splide,
      {
        ref: 'slide',
        props: { options: this.computedOptions },
        on: { 'splide:mounted': this.ready }
      },
      items.map(item => createElement(SplideSlide, [item]))
    )
  }
}
</script>

<style scoped lang="scss">
.img-carousel {
  width: auto;
  max-width: 100%;
  border-radius: 15px;
}

/deep/ .splide {
  &__slide {
    text-align: center;
  }

  &__pagination {
    &__page {
      width: 0.8125rem;
      height: 0.8125rem;
      opacity: 1;
      background: #fff;
      
      &.is-active {
        transform: scale(1);
        background: #ff8000;
      }
    }

    @media (max-width: 550px) {
      display: none;
    }
  }
}
</style>
<style lang="scss" scoped>
  /deep/ .splide__arrow {
    opacity: 1;
    background: linear-gradient(90deg, #FF7300 -3.33%, #FF5C00 100%);
    box-shadow: 0px 2.5rem4px rgba(0, 0, 0, 0.25), 5px 5px 30px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    transform: translate(0, -50%);
    
    top: 50%;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 100%;

    svg { fill: #fff; width: 50% }

    &--prev { left: 10px }
    &--next { right: 10px }

    &[disabled] { display: none }
  }
</style>
